import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { BsgGloveSize } from '../../api/models';

export type TABLE_TYPE = Table<BsgGloveSize>;

export const TABLE = 'bsgGloveSize';
const SCHEMA = 'bsgGloveSizeId, sortId';

class BsgGloveSizeDatabase implements DataRepository<BsgGloveSize> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<BsgGloveSize | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: BsgGloveSize, key: Key): Promise<BsgGloveSize> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: BsgGloveSize[]): Promise<BsgGloveSize[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<BsgGloveSize[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const BsgGloveSizeDB = new BsgGloveSizeDatabase(db);
